/** Keep motif metadata, but never disclose the current puzzle's solution depth. */
export function puzzleThemes(themes: string[]) {
  return themes.filter((theme) => !/^(mateIn\d+|oneMove|short|long|veryLong)$/.test(theme));
}
